import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Flex, Label, Radio } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var GenderPickerOption = function GenderPickerOption(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      value = _ref.value,
      containerProps = _ref.containerProps,
      onChange = _ref.onChange;
  return ___EmotionJSX(Label, {
    htmlFor: id,
    width: "auto"
  }, ___EmotionJSX(Flex, _extends({
    alignItems: "center"
  }, containerProps), ___EmotionJSX(Radio, {
    id: id,
    name: "option-gender",
    checked: checked,
    value: value,
    inputContainerProps: {
      mr: 2
    },
    onChange: onChange
  }), value === "m" ? "Male" : "Female"));
};